<template>
    <transition-group
        name="list"
        tag="ul"
        class="l-ss-c-completions-tags-group"
        @after-enter="adjustVisibleTags">
        <li
            v-for="(tag, index) in sortedTags"
            :key="`tag-${index}`"
            class="l-ss-c-completions-tags"
            @click="handleTagsClick($event, tag, index)"
            v-html="tag.label">
        </li>
    </transition-group>
</template>
<script>
    export default {
        props: {
            data: {
                type: Array,
                default: () => ([]),
            },
            isTapsComplitions: {
                type: Boolean,
                default: false,
            },
            query: {
                type: String,
                default: '',
            },
            count: {
                type: Number,
            },
        },
        computed: {
            sliceTags() {
                return this.data.slice(0, this.count);
            },
            sortedTags() {
                const tags = [...this.sliceTags];

                return tags.sort((a, b) => b.label.length - a.label.length);
            },
        },
        mounted() {
            this.adjustVisibleTags();
        },
        methods: {
            handleTagsClick(event, tag, index) {
                const query = tag.query;

                const formatTags = this.sortedTags.map(tag => tag.query);

                const trackParams = {
                    pos: index + 1,
                    selectTag: tag.query,
                    tags: formatTags,
                    event,
                };

                this.$emit('handle-tags-click', query);

                if (!this.isTapsComplitions) {
                    this.$emit('result-tab-click', {
                        type: 'resultTabClick',
                        ...trackParams,
                    });
                } else {
                    this.$emit('preview-tab-click', {
                        type: 'previewTabClick',
                        ...trackParams,
                    });
                }
            },
            adjustVisibleTags() {
                if (!this.isTapsComplitions) {
                    return;
                }

                this.$nextTick(() => {
                    const container = this.$el;

                    const tags = container.querySelectorAll('.l-ss-c-completions-tags');

                    if (tags.length === 0) return;

                    const containerWidth = container.offsetWidth;
                    const containerComputedStyle = getComputedStyle(container);
                    const gap = containerComputedStyle.gap.split(' ');
                    const columnGap = parseInt(gap[1] || 0);
                    const rowGap = parseInt(gap[0] || 0);
                    const containerPadding = {
                        left: parseInt(containerComputedStyle.paddingLeft) || 0,
                        right: parseInt(containerComputedStyle.paddingRight) || 0,
                    };
                    const containerWidthWithPadding = containerWidth - containerPadding.left - containerPadding.right;

                    let firstRowHeight = tags[0].offsetHeight;
                    let secondRowHeight = 0;
                    let width = 0;

                    for (const tag of tags) {
                        width += tag.offsetWidth + columnGap;

                        if (width > containerWidthWithPadding) {
                            secondRowHeight = tag.offsetHeight;
                            break;
                        }
                    }

                    this.$el.style.maxHeight = `${firstRowHeight + secondRowHeight + rowGap * 2 - 1}px`;
                });
            },
        },
    };
</script>
